import React, {forwardRef} from 'react';
import css from './toggle.module.scss';

export const Toggle = forwardRef(({ value, setValue }, ref) =>
  <div className={css('track', value && 'on')} onClick={() => setValue(!value)} ref={ref}>
    <div className={css('handle', value && 'on')} />
  </div>
);
